<template>
  <CDropdown
    v-auth-roles="{
      user: userAuth,
      roles: [
        const_roles.ROLE_ADMINISTRATOR,
        const_roles.ROLE_TEACHER,
        const_roles.ROLE_SECRETARY,
        const_roles.ROLE_SYSTEM,
      ],
    }"
    togglerText="Administración"
    nav
    placement="bottom-end"
  >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_ADMINISTRATOR],
      }"
      to="/profesores"
      >Profesores</CDropdownItem
    >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [
          const_roles.ROLE_ADMINISTRATOR,
          const_roles.ROLE_SECRETARY,
          const_roles.ROLE_SYSTEM,
        ],
      }"
      to="/estudiantes"
      >Estudiantes</CDropdownItem
    >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_ADMINISTRATOR],
      }"
      to="/pensums"
      >Pensums</CDropdownItem
    >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_ADMINISTRATOR],
      }"
      to="/cursos"
      >Cursos</CDropdownItem
    >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_ADMINISTRATOR, const_roles.ROLE_SECRETARY],
      }"
      to="/cursos-ofertados"
      >Cursos ofertados</CDropdownItem
    >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_TEACHER],
      }"
      to="/cursos-ofertados-profesor"
      >Cursos Asignados</CDropdownItem
    >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_TEACHER],
      }"
      to="/horarios-profesor"
      >Horarios Asignados</CDropdownItem
    >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_ADMINISTRATOR, const_roles.ROLE_SECRETARY],
      }"
      to="/ventas"
      >Ventas</CDropdownItem
    >
  </CDropdown>
</template>
<script>
import Constants from "@/plugins/constants";
export default {
  name: "AdministrationMenu",
  props: ["toggleMenu"],
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  data() {
    return {
      const_roles: Constants.roles,
    };
  },
  methods: {
    tMenu() {
      this.toggleMenu();
    },
  },
};
</script>